import React from "react";
import { isEmpty } from "lodash";
import { useLocation, useNavigate } from "react-router-dom";

import { MENU_SIDE_BAR } from "../../config/constants";
import { CommonModal } from "../commonModal/CommonModal";
import useWindowDimensions from "../../hooks/windowsSize";

import "./menuBar.scss";
import PermissionsGate from "../PermissionGate";
import { SCOPES } from "../../config/permission-maps";
import DashboardIcon from "../../assets/menuIcon/dashboardIcon";
import { menuBarIconMap } from "../../utils/menuBar";

const ModalMenuBar = ({ visibleModal, setVisibleModal = () => {} }: any) => {
  const location = useLocation();
  const navigate = useNavigate();

  var currentPath = location.pathname;
  let mainPath = currentPath.substring(0, currentPath.lastIndexOf("/"));

  let currentAvailablePath = isEmpty(mainPath) ? currentPath : mainPath;
  const { height } = useWindowDimensions();

  const loadMenuIcon = (iconName: string): JSX.Element => {
    const SelectedIcon = menuBarIconMap[iconName] || DashboardIcon;
    return <SelectedIcon />;
  };

  return (
    <CommonModal
      modalOpenState={visibleModal}
      modalCloseState={() => setVisibleModal(false)}
      centered={true}
      size="mini"
      customDimmer="customDimmer customerMenuIcon"
    >
      <div
        style={{
          height: height - 70,
        }}
      >
        <div
          className="mainMenuView"
          style={{
            height: height,
          }}
        >
          {MENU_SIDE_BAR.map((data, mainIndex) => {
            return (
              <div key={mainIndex} className="mainBarView">
                {data.subTitle.map((sub, subIndex) => {
                  if (sub?.isHidden) return null;
                  return (
                    <PermissionsGate
                      scopes={[SCOPES.canAccessInSideMenu]}
                      feature={sub.name}
                      key={subIndex}
                    >
                      <div
                        className="sideBarIcon"
                        onClick={() => navigate(sub.path)}
                      >
                        <div className="sideBarIconView">
                          {loadMenuIcon(sub.name)}
                        </div>
                        <div className="sideBarIconText">
                          <p
                            className={
                              currentAvailablePath == sub.path
                                ? "menuTitleViewSelect"
                                : "menuTitleView"
                            }
                          >
                            {sub.titleName}
                          </p>{" "}
                        </div>
                      </div>
                    </PermissionsGate>
                  );
                })}
              </div>
            );
          })}
        </div>
      </div>
    </CommonModal>
  );
};

export default ModalMenuBar;
